export { default } from './ZoomableImage'
